import { $api } from "../../../../../services/request.config";
import { getAvailableRequestsAction } from "../getAvailableRequests.action";
export const getAvailableRequestsThunkAction = () => async (dispatch) => {
    try {
        const response = await $api("/v1/manager/delegations/available-applications");

        if (response.status === 200) {
            dispatch(getAvailableRequestsAction(response.data));
        }
    } catch (error) {
        dispatch(getAvailableRequestsAction([]));
        // throw new Error("")
        // console.log("ERROR WHILE GETTING AVAILABLE EMPLOYEES: ", error);
    }
};
